module.exports = __webpack_public_path__ + "img/game_bg2.2828e24b.png";